import { Component } from '@angular/core';
import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http';
import { AuthBagService } from '../../auth/auth-bag.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from '../../../environments/environment';

@Component({
	selector: 'app-offer-refresh-button',
	templateUrl: './offer-refresh-button.component.html',
	styleUrls: ['./offer-refresh-button.component.scss'],
})
export class OfferRefreshButtonComponent {
	constructor(
		private readonly http: HttpClient,
		private readonly auth: AuthBagService,
		private readonly _snackBar: MatSnackBar,
	) {}
	protected progress = 0;
	protected processing = false;
	private httpHeadersGet() {
		if (typeof this.auth.tokenGet() === 'undefined') {
			return new HttpHeaders({
				'Content-Type': 'application/json',
			});
		}
		return new HttpHeaders({
			'Content-Type': 'application/json',
			Authorization: 'Bearer ' + this.auth.tokenGet(),
		});
	}

	private getRefreshWithProgress(): Promise<any> {
		const domain = environment.production ? '' : 'dev.';
		return new Promise((resolve, reject) => {
			this.http
				.get(`https://${domain}api.bookandgo.oskar.com.pl/refresh/`, {
					observe: 'events',
					responseType: 'json',
					reportProgress: true,
					headers: this.httpHeadersGet(),
				})
				.subscribe(
					(event) => {
						if (event.type === HttpEventType.Response) {
							resolve(event.body);
						} else if (event.type === HttpEventType.DownloadProgress) {
							this.progress = Math.round((100 * event.loaded) / event.total);
						}
					},
					(error) => {
						reject(error);
					},
				);
		});
	}

	protected generateOffers() {
		this.processing = true;
		this.getRefreshWithProgress()
			.then(() => {
				this._snackBar.open('Pomyślnie rozpoczęto generowanie', 'OK', {
					duration: 2000,
				});
			})
			.catch((error) => {
				throw new Error(JSON.stringify(error));
			})
			.finally(() => {
				this.processing = false;
				this.progress = 0;
			});
	}
}
